import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (this.authService.estConnecte()) {
      return true;
    }
    // Si pas connecte, on redirige vers la page de connexion
    this.router.navigate(['/admin/login']);
    return false;
  }
}
